import CoachOnboardingTask from './CoachOnboardingTask';

export default CoachOnboardingTask;
